// extracted by mini-css-extract-plugin
module.exports = {"progressWraper":"progressWraper--1qpfP","innerWraper":"innerWraper--TdRwl","innerText":"innerText--wQG+N"};